// extracted by mini-css-extract-plugin
export default {"video-state-wrapper":"video-state-wrapper__jSQyI","fadeOut":"fadeOut__3OmT5"};